const baseStyle = {};
const defaultProps = {};
const parts = [];
const sizes = {};
const variants = {};
export default {
    baseStyle,
    defaultProps,
    parts,
    sizes,
    variants
};
